"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _cartIntentOOI = _interopRequireDefault(require("./cartIntentOOI"));
var _providerEvents = _interopRequireDefault(require("wix-art-store-3rd-party/dist/src/sdk/providerEvents"));
var _checkoutIntentOOI = _interopRequireDefault(require("../checkout/checkoutIntentOOI"));
var _ProviderModalOOI = _interopRequireDefault(require("./ProviderModalOOI"));
var _consts = require("../consts");
var _checkoutHandler = _interopRequireDefault(require("./checkoutHandler"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PageManager = exports["default"] = /*#__PURE__*/function (_Component) {
  function PageManager(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      pagesData: {
        isMobile: props.isMobile,
        viewMode: props.viewMode,
        connectedProviders: props.connectedProviders,
        locale: props.locale,
        deviceType: props.deviceType,
        id: props.id
      }
    };
    _this.checkoutHandler = new _checkoutHandler["default"](props.baseUrl, props.closeFullscreen);
    _this.setShopEditorData = _this.setShopEditorData.bind(_this);
    _this.goToCheckout = _this.goToCheckout.bind(_this);
    _this.getCartPage = _this.getCartPage.bind(_this);
    _this.updateCartItemsIfNeeded = _this.updateCartItemsIfNeeded.bind(_this);
    _this.getShopEditorPage = _this.getShopEditorPage.bind(_this);
    _this.getCheckoutPage = _this.getCheckoutPage.bind(_this);
    _this.getPages = _this.getPages.bind(_this);
    _this.firstCartOpen = true;
    _this.updateUrl = props.updateUrl;
    return _this;
  }
  (0, _inheritsLoose2["default"])(PageManager, _Component);
  var _proto = PageManager.prototype;
  _proto.setShopEditorData = function setShopEditorData(data) {
    this.shopEditorData = data;
  };
  _proto.goToCheckout = function goToCheckout() {
    if (this.cartIntent) {
      this.cartIntent.postMessage(_providerEvents["default"].checkout, {});
    }
  };
  _proto.updateCartItemsIfNeeded = function updateCartItemsIfNeeded(cartItems) {
    if (this.shouldUpdateCartItems && this.cartIntent) {
      this.cartIntent.postMessage(_providerEvents["default"].refreshCart, cartItems);
      this.shouldUpdateCartItems = false;
    }
  };
  _proto.getCartPage = function getCartPage(data) {
    var _this2 = this;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "artstore-cart-element",
      style: {
        visibility: data.showCart ? 'visible' : 'hidden'
      }
    }, /*#__PURE__*/_react["default"].createElement(_cartIntentOOI["default"], {
      isMobile: data.isMobile,
      viewMode: data.viewMode,
      wixSdk: data.wixSdk,
      connectedProviders: data.connectedProviders,
      count: data.cartItemsCount,
      additionalProviderParams: data.additionalProviderParams,
      visible: data.showCart,
      closeCart: function closeCart() {
        return data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.CART, false);
      },
      onGoToCheckout: function onGoToCheckout(checkoutParams) {
        return _this2.checkoutHandler.handleCheckoutRequest(data, (0, _extends2["default"])({}, checkoutParams, {
          appInstance: data.appInstance
        }));
      },
      locale: data.locale,
      toggleShopEditorPage: function toggleShopEditorPage(editorData) {
        _this2.setShopEditorData(editorData);
        data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.EDITOR, true);
      },
      artStoreApi: data.storeApi,
      cartItems: data.cartItems,
      deviceType: data.deviceType,
      setCartIntent: function setCartIntent(cartIntent) {
        return _this2.cartIntent = cartIntent;
      },
      consentPolicy: data.consentPolicy,
      appInstance: data.appInstance
    }));
  };
  _proto.getShopEditorPage = function getShopEditorPage(data) {
    var _this3 = this;
    var _this$shopEditorData = this.shopEditorData,
      urlPath = _this$shopEditorData.urlPath,
      urlParams = _this$shopEditorData.urlParams,
      name = _this$shopEditorData.name,
      item = _this$shopEditorData.item,
      isDemo = _this$shopEditorData.isDemo,
      itemUrl = _this$shopEditorData.itemUrl,
      galleryId = _this$shopEditorData.galleryId;
    var isDemoItem = isDemo === undefined ? 'false' : isDemo;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "artstore-shop-editor-element"
    }, /*#__PURE__*/_react["default"].createElement(_ProviderModalOOI["default"], {
      name: name,
      urlParams: urlParams,
      urlPath: urlPath,
      wixSdk: data.wixSdk,
      additionalProviderParams: data.additionalProviderParams,
      onClose: function onClose() {
        // remove editor product id from url
        if (_this3.updateUrl) {
          var curEditorProductId = urlPath.replace('/', '');
          var neededUrl = window.location.href.replace("&product=" + curEditorProductId, '');
          _this3.updateUrl(neededUrl);
        }
        data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.EDITOR, false);
      },
      onUpdateCartItems: function onUpdateCartItems() {
        return _this3.shouldUpdateCartItems = true;
      },
      connectedProviders: data.connectedProviders,
      artStoreApi: data.storeApi,
      cartItems: data.cartItems,
      galleryId: galleryId,
      additionalParams: {
        galleryId: galleryId,
        isDemo: isDemoItem,
        itemUrl: itemUrl || item.url
      },
      consentPolicy: data.consentPolicy
    }));
  };
  _proto.getCheckoutPage = function getCheckoutPage(data) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "artstore-checkout-element"
    }, /*#__PURE__*/_react["default"].createElement(_checkoutIntentOOI["default"], {
      wixSdk: data.wixSdk,
      artStoreApi: data.storeApi,
      onClose: function onClose(openCart) {
        data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.CHECKOUT, false);
        if (openCart) {
          data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.CART, true);
        }
      },
      cartItems: data.cartItems,
      additionalProviderParams: data.additionalProviderParams,
      connectedProviders: data.connectedProviders,
      locale: data.locale,
      deviceType: data.deviceType,
      viewMode: data.viewMode,
      styleParams: {},
      checkoutParams: this.checkoutHandler.getCheckoutData(),
      consentPolicy: data.consentPolicy,
      appInstance: data.appInstance
    }));
  };
  _proto.getConsentPolicyQuery = function getConsentPolicyQuery(consentPolicy) {
    if (consentPolicy && consentPolicy.policy) {
      return encodeURIComponent(JSON.stringify(consentPolicy));
    } else {
      return undefined;
    }
  };
  _proto.getPages = function getPages(_data, _ref, widgetType) {
    var showCart = _ref.showCart,
      showCheckout = _ref.showCheckout,
      showShopEditor = _ref.showShopEditor,
      showStorePopupMessage = _ref.showStorePopupMessage;
    var commonProps = (0, _extends2["default"])({}, this.state.pagesData, {
      cartItemsCount: _data.cartItemsCount,
      cartItems: _data.cartItems,
      wixSdk: _data.wixSdk,
      storeApi: _data.storeApi,
      additionalProviderParams: _data.additionalProviderParams,
      changeStoreFrameState: _data.changeStoreFrameState,
      consentPolicy: this.getConsentPolicyQuery(_data.consentPolicy),
      appInstance: _data.appInstance
    });
    this.updateCartItemsIfNeeded(_data.cartItems);
    var dom = [this.getCartPage((0, _extends2["default"])({}, commonProps, {
      showCart: showCart
    }))];
    if (showCheckout) {
      dom.push(this.getCheckoutPage(commonProps));
    }
    if (showShopEditor) {
      dom.push(this.getShopEditorPage(commonProps));
    }
    if (showStorePopupMessage) {
      dom.push(this.checkoutHandler.getCheckoutPopupMessage(commonProps));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: this.state.pagesData.id
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "artstore-fullscreen-frames"
    }, dom));
  };
  return PageManager;
}(_react.Component);